import { useParams } from 'react-router-dom';

export const useParamsAccountId = (): number => {
	const { accountId: accountIdParam = '' } = useParams<{ accountId: string }>();
	return parseInt(accountIdParam);
};
